export default "__VITE_ASSET__DNclbt0U__"